export enum EVENT_NAMES {
  ADD_LINE_ITEM = "add-line-item",
  PROPAGATE_AMOUNT = "propagate-amount",
  TOTAL_AMOUNT_CHANGED = "total-amount-changed",
}
